import { Component } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './services/auth-service/auth.service';
import { LanguageService } from './services/language-service/language-service.service';
import { StylingService, Theme } from './services/style-service/styling.service';
import { UserService } from './services/user-service/user.service';
import { IframeRecivedService } from './shared/navbar/navbar-vesax/iframe-recieved.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone:false
})
export class AppComponent {
  appLang:string='de'
  title: any = '';

  constructor(
    public styleService: StylingService,
    private translate: TranslateService,
    private userService: UserService,
    private authService: AuthService,
    private langService: LanguageService,
    private iframeRecivedService:IframeRecivedService
  ) {
    this.translate.setDefaultLang(localStorage.getItem('language') || 'de');
    this.translate.use(localStorage.getItem('language') || 'de');
    this.langService.activeLanguage = localStorage.getItem('language') || 'de';
    this.setDefaultVesaxColors();
    this.setUpMessageListener();
  }

  ngOnInit() { }

  setUpMessageListener() {
    if (window.addEventListener) {
      window.addEventListener("message", this.receiveIframeMessage.bind(this), false);
    } else {
      (<any>window).attachEvent("onmessage", this.receiveIframeMessage.bind(this));
    }
  }

  setDefaultVesaxColors() {
    document.documentElement.style.setProperty('--mainColor', "#0ec6c6");
    document.documentElement.style.setProperty('--mainColor2', "#30eded");
    document.documentElement.style.setProperty('--bodyBg', "white");
    document.documentElement.style.setProperty('--fontColor', "black");
    document.documentElement.style.setProperty('--white-color', "white");
  }

  receiveIframeMessage(event: any) {
    console.log('parent event: ');
    console.log("event", event)
    console.log("event data",event.data);
    if (typeof event.data == 'object' && event.data.call == 'sendValue' || typeof event.data.includes=='string' && event.data.call == 'sendValue') {
      if(typeof event.data == 'object' && event.data.appLang!==undefined){
        this.appLang = event.data.appLang;
        console.log(this.appLang)
        localStorage.setItem('language', this.appLang)
        this.translate.setDefaultLang(this.appLang);
        this.translate.use(this.appLang);
        this.langService.activeLanguage = this.appLang;
      }
      if(typeof event.data == 'object' && event.data.isDesignerMode!==undefined){
        this.iframeRecivedService.isDesignerModeSub.next(event.data.isDesignerMode)
      }
      if(typeof event.data == 'object'&&event.data.isApp!==undefined){
        this.iframeRecivedService.isAppSub.next(event.data.isApp)
      }
      if(typeof event.data =='object'&&event.data.configImg!==undefined && event.data.configImg!==null ){
        this.iframeRecivedService.configImgSub.next(event.data.configImg)
      }
      if(typeof event.data == 'object'&&event.data.styleType!==undefined){
        this.iframeRecivedService.styleType = event.data.styleType;
        this.iframeRecivedService.styleTypeSub.next(event.data.styleType)
      }
      else if (typeof event.data == 'object'&&event.data?.value?.includes('img')) {
        let i = JSON.parse(event.data.value);
        this.userService.logo = i.img;
      } else if (typeof event.data == 'object'&& event.data?.value?.includes('lang')) {
        let langObj = JSON.parse(event.data.value);
        this.translate.setDefaultLang(langObj.lang);
        this.translate.use(langObj.lang);
        this.langService.activeLanguage = langObj.lang;
      }else if(typeof event.data === 'string' && event.data.includes('token')){
        let token = this.authService.getToken();
        console.log('get correct token ', token)
        parent.postMessage("token=" + token, "*");
      }
    }else if(event.data == 'object' && event.data.includes("__postRobot__")){
      this.appLang = "de"
      localStorage.setItem('language', this.appLang)
      this.translate.setDefaultLang(this.appLang);
      this.translate.use(this.appLang);
      this.langService.activeLanguage = this.appLang;
    }
  }

  public get theme(): typeof Theme {
    return Theme;
  }
}
